import pmi from './crm/pmi'
import drinksections from './catalog/sections/drinkSections'
import drinkpackages from './catalog/packages/drinkPackage'
import foodpackages from './catalog/packages/foodPackage'
import rentpackages from './catalog/packages/rentPackage'
import musicpackages from './catalog/packages/musicPackage'
import professionalpackages from './catalog/packages/professionalPackage'
import physicalpackages from './catalog/packages/physicalPackage'
import locationpackages from './catalog/packages/locationPackage'
import facets from './catalog/facets'
import foods from './catalog/food'
import drinks from './catalog/drink'
import locations from './catalog/location'
import foodsupselling from './catalog/foodUpselling'
import foodsections from './catalog/sections/foodSections'
import kampaayers from './crm/kampaayers'
import musics from './catalog/baseProduct/musics'
import musicsections from './catalog/sections/musicSections'
import events from './events'
import rents from './catalog/baseProduct/rents'
import rentsections from './catalog/sections/rentSections'
import suppliers from './crm/suppliers'
import virtuals from './catalog/virtual'
import virtualexperiencessections from './catalog/sections/virtualSections'
import virtualupselling from './catalog/upselling/virtualupselling'
import physicals from './catalog/physical'
import physicalsections from './catalog/sections/physicalSections'
import physicalupselling from './catalog/upselling/physicalUpselling'
import logistics from './catalog/logistic'
import servicesconfig from './servicesconfig'
import eventpackages from './catalog/packages/eventPackage'
import professionalsections from './catalog/sections/professionalSections'
import professionals from './catalog/professional'
import locationupselling from './catalog/upselling/locationUpselling'
import locationfeatures from './catalog/locationFeatures'
import locationsections from './catalog/sections/locationSections'
import eventbrief from './eventBrief'
import eventsdraft from './events-draft'
import { APICfg } from '../api'
import transaction from './accounting/transaction'
import organization from './crm/organizations'
import eventpackagessections from './catalog/packages/eventPackageSections'
import rules from './catalog/rules'
import coupon from './accounting/coupon'

export type UpsellingEntity =
  | 'foodsupselling'
  | 'locationupselling'
  | 'virtualupselling'
  | 'physicalupselling'

export type ProductWithUpsellingEntity =
  | 'foods'
  | 'virtuals'
  | 'locations'
  | 'physicals'

export type MainProductAPIEntity =
  | ProductWithUpsellingEntity
  | 'professionals'
  | 'musics'
  | 'drinks'
  | 'rents'

export type ProductPackageEntity =
  | 'foodpackages'
  | 'physicalpackages'
  | 'rentpackages'
  | 'musicpackages'
  | 'drinkpackages'
  | 'professionalpackages'
  | 'locationpackages'

export type PackageEntity = ProductPackageEntity | 'eventpackages'

export type APIEntity =
  | UpsellingEntity
  | MainProductAPIEntity
  | PackageEntity
  | 'pmi'
  | 'drinksections'
  | 'facets'
  | 'foodsections'
  | 'kampaayers'
  | 'musicsections'
  | 'events'
  | 'rentsections'
  | 'suppliers'
  | 'transaction'
  | 'virtualexperiencessections'
  | 'logistics'
  | 'coupon'
  | 'servicesconfig'
  | 'professionalsections'
  | 'eventbrief'
  | 'locationsections'
  | 'physicalsections'
  | 'eventsdraft'
  | 'organization'
  | 'locationfeatures'
  | 'eventpackagessections'
  | 'rules'

type ResourceApiMap = Record<APIEntity, APICfg>

const resourceApiMap: ResourceApiMap = {
  pmi,
  drinks,
  drinksections,
  drinkpackages,
  facets,
  foods,
  foodsections,
  foodsupselling,
  kampaayers,
  musics,
  musicsections,
  events,
  rents,
  rentsections,
  foodpackages,
  rentpackages,
  musicpackages,
  professionalpackages,
  physicalpackages,
  locationpackages,
  eventpackages,
  suppliers,
  transaction,
  virtuals,
  virtualexperiencessections,
  virtualupselling,
  coupon,
  logistics,
  servicesconfig,
  professionalsections,
  professionals,
  eventbrief,
  locations,
  locationupselling,
  locationsections,
  physicals,
  physicalsections,
  physicalupselling,
  eventsdraft,
  organization,
  locationfeatures,
  eventpackagessections,
  rules,
}

export default resourceApiMap
